/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Dynamic Destinations)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Form validation utilities for Dynamic Destinations.
────────────────────────────────────────────────────────────────*/

import { FormState, ValidationErrors, OptionErrors } from '../types';

/**
 * Validate Dynamic Destination form
 */
export function validateDynamicDestinationForm(
  formData: FormState,
  t: (key: string) => string
): { errors: ValidationErrors; optionErrors: OptionErrors[] } {
  const errors: ValidationErrors = {};
  const optionErrors: OptionErrors[] = [];

  if (!formData.name.trim()) {
    errors.name = t('dynamicDestination.validation.nameRequired');
  }

  if (!formData.sourceConfig.trim()) {
    errors.sourceConfig = t('dynamicDestination.validation.sourceConfigRequired');
  }

  if (!formData.matchField.trim()) {
    errors.matchField = t('dynamicDestination.validation.matchFieldRequired');
  }

  if (!formData.defaultModule.trim()) {
    errors.defaultModule = t('dynamicDestination.validation.defaultModuleRequired');
  }

  if (!formData.defaultDestination.trim()) {
    errors.defaultDestination = t('dynamicDestination.validation.defaultDestinationRequired');
  }

  if (!formData.queryTemplate.trim()) {
    errors.queryTemplate = t('dynamicDestination.validation.queryTemplateRequired');
  }

  formData.options.forEach((option, index) => {
    const optionError: OptionErrors = {};

    if (!option.matchValue.trim()) {
      optionError.matchValue = t('dynamicDestination.validation.matchValueRequired');
    }

    if (!option.destinationModule.trim()) {
      optionError.destinationModule = t('dynamicDestination.validation.destinationModuleRequired');
    }

    if (!option.destinationValue.trim()) {
      optionError.destinationValue = t('dynamicDestination.validation.destinationRequired');
    }

    optionErrors[index] = optionError;
  });

  return { errors, optionErrors };
}

